import { Card, CardContent } from '@/components/ui/card';
import { SITE_CONFIG } from '@/lib/constants';

/**
 * Privacy Policy page
 */
export function Privacy() {
  const lastUpdated = '16/12/2025';

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <span className="category-label">Legal</span>
          <h1 className="text-4xl font-bold">Privacy Policy</h1>
          <p className="mt-4 text-muted-foreground">
            Last updated: {lastUpdated}
          </p>

          <Card className="mt-8">
            <CardContent className="prose prose-invert max-w-none p-6 md:p-8">
              <div className="space-y-8">
                <section>
                  <h2 className="text-xl font-semibold text-foreground">1. Introduction</h2>
                  <p className="mt-2 text-muted-foreground">
                    {SITE_CONFIG.name} ("we", "our", or "us") is committed to protecting
                    your privacy. This Privacy Policy explains how we collect, use, and
                    safeguard your personal information when you use our website and services.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">2. Information We Collect</h2>
                  <p className="mt-2 text-muted-foreground">
                    We collect information that you voluntarily provide to us when you:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Fill out our contact form</li>
                    <li>Request a quote for services</li>
                    <li>Communicate with us via email or phone</li>
                    <li>Make enquiries about gallery items</li>
                  </ul>
                  <p className="mt-4 text-muted-foreground">
                    This information may include your name, email address, phone number,
                    and any details you provide about your service requirements.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">3. How We Use Your Information</h2>
                  <p className="mt-2 text-muted-foreground">
                    We use the information we collect to:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Respond to your enquiries and provide quotes</li>
                    <li>Deliver the services you have requested</li>
                    <li>Communicate with you about your service requirements</li>
                    <li>Improve our website and services</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">4. Cookies and Analytics</h2>
                  <p className="mt-2 text-muted-foreground">
                    Our website may use Cloudflare Analytics to help us understand how
                    visitors interact with our site. This service collects anonymised
                    data and does not use cookies or track individual users.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">5. Data Storage and Security</h2>
                  <p className="mt-2 text-muted-foreground">
                    Your personal information is stored securely and retained only for
                    as long as necessary to fulfil the purposes outlined in this policy.
                    We implement appropriate technical and organisational measures to
                    protect your data.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">6. Third-Party Services</h2>
                  <p className="mt-2 text-muted-foreground">
                    We may use third-party services for hosting (Cloudflare), email
                    communication, and analytics. These services have their own privacy
                    policies governing the use of your information.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">7. Your Rights</h2>
                  <p className="mt-2 text-muted-foreground">
                    You have the right to:
                  </p>
                  <ul className="mt-2 list-disc pl-5 text-muted-foreground space-y-1">
                    <li>Access the personal information we hold about you</li>
                    <li>Request correction of inaccurate information</li>
                    <li>Request deletion of your personal information</li>
                    <li>Withdraw consent for data processing</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-foreground">8. Contact Us</h2>
                  <p className="mt-2 text-muted-foreground">
                    If you have any questions about this Privacy Policy or wish to
                    exercise your rights, please contact us at{' '}
                    <a
                      href={`mailto:${SITE_CONFIG.contact.email}`}
                      className="text-primary hover:underline"
                    >
                      {SITE_CONFIG.contact.email}
                    </a>
                    .
                  </p>
                </section>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
